import './NoDataFound.scss'
import React from 'react'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

function NoDataFound() {
  const {t} = useTranslation()
  return (
    <Stack sx={{mt: '25vh', width: '100%'}} alignItems="center" justifyContent="center">
      <Typography
            className="ff-Roboto fw-regular fs-24"
            style={{ color: '#707070' }}
          >
           {t(`We couldn't find any data for your request`)}
          </Typography>
    </Stack>
  )
}

export default NoDataFound